import React from 'react';
import { Input, Icon, Tooltip, AutoComplete, Select, Button  } from 'antd';
import SERVER_URL from '../Global';

const { Option } = Select;

class HandleAddress extends React.Component {
    constructor(props) {
        super(props);

        let index = 0

        let streetName = null

        let addressResult = null

        if (this.props.streetName != null) {
            streetName = this.props.streetName
        }

        if (this.props.index != null) {
            if (this.props.addressResult != null) {
                if (this.props.addressResult.includes("§N.A.§")) {
                    addressResult = this.props.addressResult.replace("§N.A.§", "N/A")
                } else {
                    addressResult = this.props.addressResult
                }
            } 
        }

        if (this.props.index != null) {
            index = this.props.index
        }

        this.state = {
            zipCodesArray: [],
            citiesArray: [],
            user: this.props.user,
            searchZip: false,
            searchCity: false,
            addressResult: addressResult,
            zipResult: null,
            cityResult: null,
            index: index,
            streetName: streetName,
            legal: false,
            administrative: false,
            operational: false,
        };

        this.handleStreetName = this.handleStreetName.bind(this);
        this.searchZipCodes = this.searchZipCodes.bind(this);
        this.handleZipCode = this.handleZipCode.bind(this);
        this.searchCities = this.searchCities.bind(this);
        this.handleCities = this.handleCities.bind(this);
        this.deleteAddressResult = this.deleteAddressResult.bind(this);
        this.handleResult = this.handleResult.bind(this);
        this.clearResult = this.clearResult.bind(this);
        this.handleLegal = this.handleLegal.bind(this);
        this.handleAdministrative = this.handleAdministrative.bind(this);
        this.handleOperational = this.handleOperational.bind(this);
    }

    handleStreetName(e) {
        var newInput = e.target.value
        if (e.target.value.length == 0) {
            newInput = null
        }
        this.props.parentCallback(newInput, this.state.index);
        this.setState({ streetName: newInput })
    }

    handleZipCode(value) {
        var zipCodeId = value.substr(0, value.indexOf('/'));
        var CityId = value.substring(value.indexOf('/') + 1, value.indexOf('$'));
        var result = value.substr(value.indexOf('$') + 1);
        this.props.parentCallbackZip(zipCodeId, this.state.index);
        this.props.parentCallbackCity(CityId, this.state.index);
        this.setState({ searchCity: true, addressResult: result });
        this.clearResult()
    }

    handleCities(value) {
        var zipCodeId = value.substr(0, value.indexOf('/'));
        var CityId = value.substring(value.indexOf('/') + 1, value.indexOf('$'));
        var result = value.substr(value.indexOf('$') + 1);
        this.props.parentCallbackZip(zipCodeId, this.state.index);
        this.props.parentCallbackCity(CityId, this.state.index);
        this.setState({ searchZip: true, addressResult: result });
        this.clearResult()        
    }

    searchZipCodes(value) {
        this.setState({ zipResult: value})
            //zipCodes
            fetch(
                `${SERVER_URL + 'api/zipCode/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "value": value,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 10,
                        "pageSizeOptions": null,
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "ordering": {
                            "order": -1
                        },
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    let zipCodesArray = []

                    res.data.map(obj => {
                        obj.brCityZipCodes.map(city =>
                            zipCodesArray.push({ city: city, obj: obj })
                            )
                    })

                    this.setState({ zipCodesArray: zipCodesArray });
                }
            })
            if (value.length == 0) {
                this.setState({ searchCity: false });
            }
    }

    handleResult() {
        this.clearResult()
    }

    searchCities(value) {
        this.setState({ cityResult: value })
        if (value.length >= 3 || value.length === 0) {
            //City
            fetch(
                `${SERVER_URL + 'api/city/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "name": value,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 10,
                        "pageSizeOptions": null,
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "ordering": {
                            "orderPropertyName": "name",
                            "order": 1
                        },
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {

                        let zip = []
                        res.data.map(o =>
                            o.brCityZipCodes.map(br =>
                                zip.push({ city: o, br: br })
                            ))
                        this.setState({ citiesArray: zip });                   
                    }
                })
            if (value.length == 0) {
                this.setState({ searchZip: false });
            }
        }
    }

    deleteAddressResult() {
        this.setState({ addressResult: null, streetName: null });
        this.props.parentCallbackZip(null, this.state.index);
        this.props.parentCallbackCity(null, this.state.index);
    }

    clearResult() {
        this.setState({ zipResult: null, cityResult: null })
    }

    handleLegal(e) {
        this.setState({ legal: e.target.checked })
    }

    handleAdministrative(e) {
        this.setState({ administrative: e.target.checked })
    }

    handleOperational(e) {
        this.setState({ operational: e.target.checked })
    }

    render() {

        let listZipCodes = this.state.zipCodesArray.map(zip => {
            let regionNan = zip.city.city.province.region.name == "§N.A.§" ? "N/A" : zip.city.city.province.region.name
            let provinceNan = zip.city.city.province.name == "§N.A.§" ? "N/A" : zip.city.city.province.name
            return (
                <Option key={zip.city.cityId} value={`${zip.city.zipCodeId}/${zip.city.cityId}$${zip.obj.value}, ${zip.city.city.name} (${provinceNan}) ${regionNan}`}>{zip.obj.value + ", " + zip.city.city.name + " (" + provinceNan + ") " + regionNan}</Option>
            )
        })

        let listCities = this.state.citiesArray.map(obj => {
            let regionNan = obj.city.province.region.name == "§N.A.§" ? "N/A" : obj.city.province.region.name
            let provinceNan = obj.city.province.name == "§N.A.§" ? "N/A" : obj.city.province.name
            return (
                <Option key={obj.br.zipCode.value} value={`${obj.br.zipCodeId}/${obj.city.cityId}$${obj.br.zipCode.value}, ${obj.city.name} (${provinceNan}) ${regionNan}`}>{obj.br.zipCode.value + ", " + obj.city.name + " (" + provinceNan + ") " + regionNan}</Option>
            )
        })

        let deleteInput = this.state.addressResult != null || this.state.streetName != null ? <Button className="deleteFakeInput" onClick={this.deleteAddressResult}><Icon type="close" /></ Button> : ""

        let afterStreetName = this.state.streetName != null ? "afterStreetNameT" : null

        let addressNa = this.state.addressResult != null ? this.state.addressResult.includes("§N.A.§") ? this.state.addressResult.replace("§N.A.§", "N/A") : this.state.addressResult : null

        return (
            <div className="adressOfficeBox">
                <div className="wizardCompanyCreation solo" style={{ display: 'inline-flex' }} sm="12">
                    <div style={{ width: '48%' }}>
                        <Tooltip placement="topLeft" title="Insert here the Office street name">
                        <h4><Icon type="info-circle" /> Street Name</h4>
                        </Tooltip>
                        <div style={{ width: '100%' }}>
                            <Input autoComplete="new-password" className="streetNameInput" value={this.state.streetName} onChange={this.handleStreetName} placeholder="Street Name" />
                        </div>
                    </div>
                    <div style={{ width: '48%', marginLeft:'4%' }}>
                        <div className="wizardCompanyCreation" sm="12">
                            <Tooltip placement="topLeft" title="Type here the Zip Code or the City Name to find the Zip-Code, City Name, Province and Region">
                                <h4><Icon type="info-circle" /> Search for:</h4>
                            </Tooltip>
                        </div>
                        <div style={{ display: "inline-flex", width: '100%' }} className="wizardCompanyCreation" sm="12">

                            <div style={{ width: '35%' }}>
                                <AutoComplete
                                    style={{ width: '100%' }}
                                    dataSource={listZipCodes}
                                    value={this.state.zipResult}
                                    onSelect={this.handleZipCode}
                                    onSearch={this.searchZipCodes}
                                    onChange={this.handleResult}
                                    placeholder="ZipCode"
                                    dropdownMenuStyle={{ width: '292px', backgroundColor: 'white', boxShadow:'0px 0px 5px 3px #e6d8d8' }}
                                />
                            </div>
                            <div style={{ width: '67%', marginLeft: '-2%' }}>
                                <AutoComplete
                                    style={{ width: '100%' }}
                                    dataSource={listCities}
                                    value={this.state.cityResult}
                                    onSelect={this.handleCities}
                                    onSearch={this.searchCities}
                                    onChange={this.handleResult}
                                    placeholder="City Name"
                                    onBlur={this.clearResult}
                                    dropdownMenuStyle={{ width: '292px', backgroundColor: 'white', boxShadow: '0px 0px 5px 3px #e6d8d8' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ width: '100%' }}>

                    <div style={{ display: "inline-flex", width: '100%' }}>

                        <div style={{ width: '100%' }}>
                            <div style={{ width: '100%' }}>
                                <Tooltip placement="topLeft" title="The Address you selected">
                                    <h4><Icon type="info-circle" /> Selected Address</h4>
                                </Tooltip>
                            </div>

                            <div className="tipoInput">
                                <h4 className={afterStreetName}>{this.state.streetName}</h4>
                                <h4>{addressNa}</h4>{deleteInput}
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>

            );

    }
}

export default HandleAddress;


// WEBPACK FOOTER //
// ./src/Wizard/HandleAddress.js